import routerOptions0 from "/home/bun/app/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/bun/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}